<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M13 1C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H13ZM2.93945 4.75098L3.46973 5.28125L4.5625 6.375L2.93945 7.99805L4 9.05859L5.82227 7.23633C6.29798 6.76035 6.29815 5.98856 5.82227 5.5127L4 3.69043L2.93945 4.75098ZM7.5 7.5V9H13V7.5H7.5Z"
    fill="currentColor"
  />
</svg>
